import React, { useEffect, useState } from 'react';
import { PagePermissionEntityInterface } from '@types';
import { FeatureConfigurationItem } from './FeatureConfigurationItem';
import { FeaturePermission, PagePermission, PermissionActions } from '@enums';
import { FeatureConfigurationGroupItem } from './FeatureConfigurationGroupItem';

interface Props {
  pagePermission: PagePermissionEntityInterface;
}
const FeatureConfigurationList = ({ pagePermission }: Props) => {
  const [groupListFeature, setGroupListFeature] = useState(null);
  const [featuresWithoutInstanceKey, setFeaturesWithoutInstanceKey] = useState(null);
  const [featuresInstanceKey, setFeaturesInstanceKey] = useState(null);

  useEffect(() => {
    if (pagePermission.featurePermissions) {
      setFeaturesWithoutInstanceKey(
        pagePermission.featurePermissions.filter((feature) => !feature.instanceKey)
      );
    }
  }, [pagePermission]);

  useEffect(() => {
    if (featuresWithoutInstanceKey && pagePermission.name === PagePermission.Letters) {
      setGroupListFeature(
        featuresWithoutInstanceKey.find((feature) => feature.name === FeaturePermission.GroupList)
      );
      setFeaturesInstanceKey(
        pagePermission.featurePermissions.filter((feature) => feature.instanceKey)
      );
    }
  }, [featuresWithoutInstanceKey]);

  return (
    <>
      {featuresInstanceKey && (
        <div>
          <FeatureConfigurationGroupItem
            pagePermission={pagePermission}
            features={featuresInstanceKey}
            externalFeature={groupListFeature}
          />
        </div>
      )}
      {featuresWithoutInstanceKey &&
        featuresWithoutInstanceKey.map((feature) => {
          return (
            feature[PermissionActions.View] !== null && (
              <FeatureConfigurationItem
                key={feature.id}
                feature={feature}
                pagePermission={pagePermission}
              />
            )
          );
        })}
    </>
  );
};

export { FeatureConfigurationList };
